import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';

import { CardSection, Flex, PhonePreview } from '@/lib/v2/components';

import { useSmsSummaryMain } from '@/src/modules/CampaignsModule/screens/ActionManagement/Sms/SmsSummaryMain/useSmsSummaryMain.hooks';

import { atomGlobalLoadingAction } from '@/modules/CampaignsModule/atoms/actionEmailAtom';
import { atomCallbackReportSmsStep } from '@/modules/CampaignsModule/atoms/actionsAtom';
import { atomActionInfoSms } from '@/modules/CampaignsModule/atoms/actionSMSAtom';
import { atomActionData } from '@/modules/CampaignsModule/atoms/campaignAtom';
import { SmsSummary } from '@/modules/CampaignsModule/components/actionManagement/SmsAction/components/SmsSummary';
import { replaceUrlsWithShortLinks } from '@/modules/CampaignsModule/components/actionManagement/SmsAction/utils';
import { ConfirmAction } from '@/modules/CampaignsModule/components/CampaignsModal/ConfirmAction';
import { SummarySkeleton } from '@/modules/CampaignsModule/components/SummaryAction/SummarySkeleton';

const SmsSummaryMain = () => {
  const actionInfoSms = useAtomValue(atomActionInfoSms);
  const globalLoadingAction = useAtomValue(atomGlobalLoadingAction);
  // cspell: disable
  const action = useAtomValue(atomActionData);

  const message = useMemo(() => {
    const currentMessage = actionInfoSms?.mensaje;
    const shortenedWhatsApp = replaceUrlsWithShortLinks(currentMessage ?? '');
    return action?.trackingUrl ? shortenedWhatsApp : currentMessage;
  }, [actionInfoSms?.mensaje, action]);
  // cspell: enable

  const {
    events: { handleConfirmAction, handleReportClick },
    state: { loading },
  } = useSmsSummaryMain();

  const setCallbackReportSmsStep = useSetAtom(atomCallbackReportSmsStep);

  useEffect(() => {
    setCallbackReportSmsStep(() => handleReportClick);
  }, [setCallbackReportSmsStep, handleReportClick]);

  return (
    <>
      <div className="relative z-[0] bg-white">
        <CardSection noPadding>
          <Flex column>
            <Flex itemAlignment="start">
              <div className="my-12 w-1/2 bg-white px-10">
                {globalLoadingAction ? <SummarySkeleton /> : <SmsSummary />}
              </div>
              <div className="grid min-h-[calc(100dvh-145px)] w-1/2 items-center justify-center bg-[#F4F5FA] py-4">
                {
                  /* cspell:disable */
                  <PhonePreview
                    loading={globalLoadingAction || Object.keys(actionInfoSms).length === 0}
                    message={message}
                  />
                  /* cspell:enable */
                }
              </div>
            </Flex>
          </Flex>
        </CardSection>
      </div>
      <ConfirmAction loading={loading} onConfirm={handleConfirmAction} />
    </>
  );
};

export default SmsSummaryMain;
